export const config_settings = {
    //ecommerce credentials
    //AUTH_SERVER_URL : 'http://localhost:8084',
    //RESOURCE_SERVER_URL : 'http://localhost:8083/store/2',

    AUTH_SERVER_URL : 'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/client-auth',
    RESOURCE_SERVER_URL : 'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/client-resource/store/2',
    PHOTO_SERVER_URL : 'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/photo-server',

    //AUTH_SERVER_URL : 'http://earmaq-client-auth-lb-1157490916.us-west-2.elb.amazonaws.com:8084',
    //RESOURCE_SERVER_URL : 'http://earmaq-client-resource-lb-946996600.us-west-2.elb.amazonaws.com:8083',
    //WEB_RESOURCE_SERVER_URL : 'http://localhost:8083/store/1',

    //OTHER_SERVICES_RESOURCE_SERVER_URL : 'http://localhost/armaq-php/public',
    OTHER_SERVICES_RESOURCE_SERVER_URL : 'https://www.armaqpesca.com.pe/armaq-php/public',
    
    DOUBLE_LANGUAGE : false,
    STORE: 2
}